/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState, useEffect} from 'react';
// material
import StackableChart from './stackablechart/stackablechart';
// styles
import injectSheet from 'react-jss';
import styles from './stackedcharts_styles';



/* ========== ~~~~~~~~~~ STACKED CHARTS ~~~~~~~~~~ ========== */
const StackedCharts = injectSheet(styles)((props) => {
    const [currentPosition, setCurrentPosition] = useState({x: null, y: null, data: {x: null, y: null}});
    const [currentYAxes, setCurrentYAxes] = useState([...props.datasets].map(dataset => ({id: dataset.id, y: 0})));
    const [lockedPosition, lockCurrentPosition] = useState({x: null, y: null, data: {x: null, y: null}});
    const [locked, lock] = useState(false);
    const handleClick = (e) => props.moreDetails ? props.moreDetails.action() : null;

    useEffect(() => {
        if(props.reset && locked) {
            lock(false);
            setCurrentPosition({x: 0, y: 0, data: {x: 0, y: 0}});
        }
    }, [props.reset]);

    const hasSingleData = dataset => {
        return dataset.data && dataset.data[0] && dataset.data[0].data.length === 1  ? true : false
    }

    const handleMouseLeave = e => {
        if(!locked && props.onMouseLeave) {
            setCurrentPosition({x: 0, y: 0, data: {x: 0, y: 0}});
            props.onMouseLeave();
        }
    }

    return (
        <div className={`chart stackedcharts ${props.classes.stackedcharts} hasDetails-${props.moreDetails ? props.moreDetails : false}`} onClick={handleClick}>
            <div className={`data`} onMouseLeave={handleMouseLeave}>
                { props.datasets.map((dataset, index) => 
                    <StackableChart
                        id={dataset.id}
                        index={index}
                        key={`stackedchart-${index}`}
                        period={props.period}
                        datasets={props.datasets}
                        data={dataset.data}
                        enablePoints={hasSingleData(dataset)}
                        currentYAxes={currentYAxes}
                        setCurrentYAxes={setCurrentYAxes}
                        setCurrentPosition={setCurrentPosition}
                        currentPosition={currentPosition}
                        lockCurrentPosition={lockCurrentPosition}
                        lockedPosition={lockedPosition}
                        locked={locked}
                        lock={lock}
                        xType={props.xType}
                        color={dataset.color}
                        last={index === props.datasets.length - 1}
                        axisBottom={index === props.datasets.length - 1 ? {
                            orient: "bottom",
                            tickSize: 0,
                            tickPadding: 20,
                            tickRotation: 0,
                            legend: "",
                            legendOffset: 36,
                            legendPosition: "middle",
                            tickValues: 5
                        } : null }
                        onMouseMove={props.onMouseMove}
                        onMouseLeave={props.onMouseLeave}
                    />
                )}
            </div>
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default StackedCharts;
